// Furnio contact page — project-type picker (writes into a hidden form field).
(function () {
  "use strict";

  function init() {
    var picker = document.querySelector("[data-fx-proj-picker]");
    if (!picker) return;
    var buttons = picker.querySelectorAll("[data-fx-proj-type]");
    var hidden = picker.querySelector("[data-fx-proj-value]");

    buttons.forEach(function (b) {
      b.addEventListener("click", function () {
        buttons.forEach(function (x) { x.classList.remove("is-active"); });
        b.classList.add("is-active");
        if (hidden) hidden.value = b.getAttribute("data-fx-proj-type");
      });
    });
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
